module.exports = __webpack_public_path__ + "0cad9d57edbe2137a2d71efe14072191.svg";